export enum PdgmTimingEnum {
  Early = 1,
  Late = 2
}

export const PdgmTimingOptions = [
{ id: 1, label: 'Early' },
{ id: 2, label: 'Late' }
];
